import React from 'react';
import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from "@mui/material";
import { WarningAmberRounded } from "@mui/icons-material";
import { toPriceWithComma } from "../../../helper/utils";

const _InvoiceCancelModal = ({
    itemToCancel,
    onClose,
    submitting,
    handleCancelInvoice,
}) => {
    return (
        <Dialog
            open={!!itemToCancel}
            onClose={() => !submitting && onClose()}
            maxWidth="xs"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 4,
                    p: 1,
                    boxShadow: '0 20px 45px rgba(0,0,0,0.12)'
                }
            }}
        >
            <Box component="form" onSubmit={handleCancelInvoice}>
                <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1.5, pb: 1 }}>
                    <Box
                        sx={{
                            width: 40,
                            height: 40,
                            borderRadius: '50%',
                            bgcolor: 'rgba(239, 68, 68, 0.1)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: 'error.main'
                        }}
                    >
                        <WarningAmberRounded />
                    </Box>
                    <Typography variant="h6" sx={{ fontWeight: 800, fontSize: '1.05rem' }}>
                        حذف پیش‌فاکتور
                    </Typography>
                </DialogTitle>

                <DialogContent sx={{ pt: 1 }}>
                    <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.8 }}>
                        آیا از لغو و حذف پیش‌فاکتور به مبلغ <strong>{toPriceWithComma(itemToCancel?.Amount)} تومان</strong> اطمینان دارید؟
                    </Typography>
                </DialogContent>

                <DialogActions sx={{ px: 3, pb: 2, pt: 1, gap: 1 }}>
                    <Button
                        variant="text"
                        onClick={onClose}
                        disabled={submitting}
                        sx={{ borderRadius: 2.5, px: 2, color: 'text.secondary' }}
                    >
                        انصراف
                    </Button>
                    <Button
                        type="submit"
                        variant="contained"
                        color="error"
                        disabled={submitting}
                        sx={{
                            borderRadius: 2.5,
                            px: 3,
                            fontWeight: 700,
                            boxShadow: '0 4px 14px rgba(239, 68, 68, 0.25)'
                        }}
                    >
                        {submitting ? <CircularProgress size={20} color="inherit" /> : "بله، حذف شود"}
                    </Button>
                </DialogActions>
            </Box>
        </Dialog>
    );
};

export default _InvoiceCancelModal;
